<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>选课学生</p>
    </div>
    <div class="panel-content center_content">
      <div class="course_info">
        <div class="panel-title">
          <p v-if="lessonInfo">{{ lessonInfo ? lessonInfo.title : '' }}</p>
          <p v-if="lessonInfo">负责人:{{  lessonInfo.manager &&  lessonInfo.manager ? lessonInfo.manager.name : '' }}</p>
        </div>
        <div class="course_btn">
          <div
            class="add-btn"
            style="margin-bottom:0;"
            @click="showUserWindow"
          >添加选课学生
          </div>
          <div
            class="import-btn"
            id="batchUpload"
            @click="showUploadWindow"
          >
            导入
          </div>
          <!-- <router-link
            tag="div"
            :to="'/www/lesson_detail?id=' + lessonInfo.id"
            class="add-btn"
          >预览</router-link> -->
        </div>
      </div>

      <div id="list">
        <table>
          <tbody>
            <tr class="l_header">
              <th class="itemStatus">
                <a
                  href="javascript:void(0)"
                  @click="selectAll"
                >全选</a>
              </th>
              <th class="itemStatus">头像</th>
              <th class="itemStatus">账号</th>
              <th class="itemStatus">姓名</th>
              <th class="itemStatus">性别</th>
              <th class="itemStatus">学院</th>
              <th class="itemStatus">专业</th>
              <th class="itemStatus">选课时间</th>
              <th class="itemStatus">班级名称</th>
              <th
                class="action"
                width="130"
              >操作
              </th>
            </tr>
            <tr
              class="item"
              v-for="(item, index) in tableData"
              :key="index"
            >
              <td>
                <input
                  type="checkbox"
                  :checked="item.checked"
                  @click="item.checked = !item.checked"
                >
              </td>
              <td>
                <img
                  :src="item.userProfile.avatar? item.userProfile.avatar : '/images/default.jpg'"
                  :onerror="$store.state.defaultHeadImg"
                >
              </td>
              <td>{{ item.userProfile.username }}</td>
              <td>{{ item.userProfile.name }}</td>
              <td>{{ formatGender(item.userProfile.gender) }}</td>
              <td>{{ formatAcademy(item.userProfile.academy) }}</td>
              <td>{{ formatMajor(item.userProfile.major)}}</td>
              <td>{{ item.created.toString().substr(0, 10) }}</td>
              <td>{{ item.onlineClass ? item.onlineClass.title : '' }}</td>
              <td>
                <a
                  class="edit"
                  v-if="!item.onlineClass"
                  href="javascript:void(0)"
                  @click="openClassWindow(item)"
                >分配班级</a>
                <br>
                <a
                  class="delete"
                  v-if="item.onlineClass"
                  href="javascript:void(0)"
                  @click="deleteClass(item)"
                >移除班级</a>
                <a
                  class="nopublish"
                  href="javascript:;"
                  @click="cancelLesson(item)"
                >取消选课</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-if="tableData.length == 0"
        >没有数据</div>
      </div>
      <!-- 批量按钮 -->
      <ul
        class="batchBtns"
        id="batchBtns"
      >
        <li>
          <input
            type="button"
            class="enable-btn"
            id="batchEnableBtn"
            value="批量分配班级"
            @click="openBatchClassWindow"
          />
        </li>
      </ul>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
    <!-- 用户弹窗 -->
    <div
      id="c-panel"
      :style="classShowUserWindow"
    >
      <div id="c-panel-bg"></div>

      <div class="c-content">
        <form
          id="search"
          onsubmit="return false;"
        >
          <input
            type="text"
            class="s-text"
            placeholder="用户名"
            autocomplete="off"
            v-model="formSearchUser.username"
          >
          <input
            type="text"
            class="s-text"
            placeholder="姓名"
            autocomplete="off"
            v-model="formSearchUser.name"
          >
          <select
            class="s-text"
            v-model="formSearchUser.school_id"
            @change="getSchoolAcademy(formSearchUser.school_id)"
          >
            <option value=''>请选择学校</option>
            <option
              v-for="(item, index) in searceSchoolData"
              :key="index"
              :value="item.id"
            >
              {{ item.title }}
            </option>
          </select>
          <select
            class="s-text"
            v-model="formSearchUser.academy_id"
          >
            <option value=''>请选择院系</option>
            <option
              v-for="item in searchAcademyData"
              :key="item.id"
              :value="item.id"
            >
              {{ item.title }}
            </option>
          </select>
          <input
            type="submit"
            class="s-btn1"
            @click="formSearchUser.page = 1;getUserList()"
            value="查询"
          >
          <span
            class="close-cpanel"
            @click="hideUserWindow"
          ></span>
        </form>
        <div id="uList">
          <table>
            <tbody>
              <tr class="l_header">
                <th>用户名</th>
                <th>姓名</th>
                <th>性别</th>
                <th>学校</th>
                <th>院系</th>
                <th class="action">操作</th>
              </tr>
              <tr
                class="item"
                v-for="(item,index) in userData"
                :key="index"
              >
                <td>{{ item.username }}</td>
                <td>{{ item.name }}</td>
                <td>{{ formatGender(item.gender) }}</td>
                <td>{{item.school?item.school.title:'--'}}</td>
                <td>{{ item.academy?item.academy.title:'--' }}</td>
                <td class="action">
                  <a
                    class="a-button"
                    href="javascript:;"
                    @click="addOnlineStudent(item)"
                  >选择</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 分页 -->
        <pagination
          :cur='teacherPageInfo.page'
          :all='teacherPageInfo.all'
          :totalData="teacherPageInfo.totalData"
          :callback="pageUserCallback"
        ></pagination>
      </div>
    </div>
    <!-- 选择班级弹窗-->
    <div
      class="form_overlay"
      style="z-index: 2;"
      :style="classShowClassWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">分配班级</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require">*</i>班级:</span>
              <select v-model="formClass.onlineClass_id">
                <option value="">请选择班级</option>
                <option
                  :value="item.id"
                  :key="item.id"
                  v-for="item in classData"
                >{{item.title}}</option>
              </select>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideClassWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="saveClassInfo"
          >提交</a>
        </div>
      </div>
    </div>
    <!-- 批量弹窗-->
    <div
      class="form_overlay"
      style="z-index: 2;"
      :style="classShowBatchClassWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">批量分配班级</div>
        <div class="form_content">
          <form>
            <div class="item">
              <span class="label"><i class="require">*</i>班级:</span>
              <select v-model="formBatchClass.onlineClass_id">
                <option value="">请选择班级</option>
                <option
                  :value="item.id"
                  :key="item.id"
                  v-for="item in classData"
                >{{item.title}}</option>
              </select>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            @click="hideBatchClassWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            @click="saveBatchClassInfo"
          >提交</a>
        </div>
      </div>
    </div>
    <!-- 导入选课学生窗口 -->
    <div
      class="form_overlay"
      :style="classShowUploadWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">批量上传</div>
        <div class="form_content">
          <form id="uploadForm">
            <div class="item">
                <span
                  class="label"
                  style="width: auto"
                >
                  <i class="require"></i>模版创建规则:
                </span>
              <div class="item-box divLabel gray">
                <div class="normal-width">
                  <p>
                    1. 文件格式为常用的Excel文件（*.xls）；
                  </p>
                  <p>
                    2.填写导入数据时，需先删除导入模版中首行以下所有说明示例数据；
                  </p>
                  <p>
                    3.导入的数据总条数建议不超过500条，如超过，建议分多次导入；
                  </p>
                  <p>
                    4.表格头说明：用户名(学/工号)、姓名;
                  </p>
                  <p>
                    <a
                      href="/static/upload_template/batch_upload_online_student_template.xls"
                      download="batch_upload_online_student_template.xls"
                      target="_blank"
                    >模版下载</a>
                  </p>
                </div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="item">
                <span
                  class="label"
                  style="width: auto"
                >
                  <i class="require">*</i>xls文件:
                </span>
              <div
                class="item-box"
                style="margin-left: 40px"
              >
                <input
                  v-model="uploadedCsv"
                  disabled
                  type="text"
                  id="fileUrl"
                  style="width: 225px"
                />
                <span
                  class="button"
                  style="position: relative; top: 0px; left: 0px"
                >
                    选择文件
                    <input
                      @change="xlsChange"
                      type="file"
                      accept=".csv,.xls,.xlsx"
                      ref="xlsFile"
                      id="fileUpload"
                      class="upload-derict"
                    />
                  </span>
              </div>
              <div class="clear"></div>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            style="width: 30px"
            class="button close"
            id="form_upload_close"
            @click="hideUploadWindow"
          >取消</a>
          <a
            href="javascript:;"
            style="width: 30px"
            class="button"
            id="form_upload_submit"
            @click="submitCsv"
          >提交</a>
        </div>
      </div>
    </div>
    <!-- 导入进度 -->
    <div
      id="dialog_overlay"
      :style="classShowProcessWindow"
    >
      <div id="dialog_bg"></div>
      <div
        id="dialog_panel"
        ref="refErrorList"
        style="margin-left: -136px; margin-top: -54px;max-width: 300px;"
      >
        <div id="dialog_panel_bg"></div>
        <div id="dialog_title">提示</div>
        <div id="dialog_content">
          ({{ curCsvIndex }} / {{ uploadedCscData.length }})
          <span style="color: #219d2b">
              {{ ' ' + csvFinishText }}
            </span>
        </div>
        <div id="dialog_content2">
          <ul>
            <li
              v-for="(item, index) in errorList"
              v-bind:key="index"
            >
              <span :class="item.code == 1 ? 'success' : 'fail'">{{ item.text }}</span>
            </li>
          </ul>

        </div>
        <div id="dialog_control">
          <a
            href="javascript:void(0)"
            id="dialog_ok"
            class="button col2"
            @click="classShowProcessWindow={}"
            :style="isFinishUpsert ? 'display: inline-block' : 'display:none'"
          >确认</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'

export default {
  name: 'OnlineStudent',
  components: {
    Pagination
  },
  props: [
    'lessonInfo'
  ],
  data() {
    return {
      academyData: [],
      classData: [],
      classShowUserWindow: {
        visibility: 'hidden'
      },
      classShowClassWindow: {
        visibility: 'hidden'
      },
      classShowBatchClassWindow: {
        visibility: 'hidden'
      },
      queryInfo: {
        page: 1,
        size: 10,
        lessonOnline_id: this.$route.query.id
      },
      tableData: [],
      tableDataCount: 0,
      formSearchUser: {
        page: 1,
        size: 10,
        username: '',
        name: '',
        role: '12',
        school_id: '',
        academy_id: ''
      },
      userData: [],
      userDataCount: 0,
      formClass: {
        onlineStudent_id: null,
        onlineClass_id: ''
      },
      formBatchClass: {
        onlineClass_id: '',
        studentIds: []
      },
      subjectData: [],
      searceSchoolData: [],
      searchAcademyData: [],
      classShowUploadWindow: {},

      uploadedCsv: '',
      uploadedCscData: [],
      classShowProcessWindow: {},
      isFinishUpsert: false,
      curCsvIndex: 0,
      csvFinishText: '',
      errorList: []
    }
  },
  methods: {
    showUserWindow() {
      this.userData = []
      this.userDataCount = 0
      this.formSearchUser.username = ''
      this.formSearchUser.name = ''
      this.formSearchUser.school_id = ''
      this.formSearchUser.academy_id = ''
      this.formSearchUser.page = 1
      this.classShowUserWindow = {
        visibility: 'visible'
      }
      this.getUserList()
    },
    hideUserWindow() {
      this.classShowUserWindow = {
        visibility: 'hidden'
      }
    },
    async searchSubject() {
      await this.$http.get('/major/', {
        params: {
          page: 1,
          size: 10000
        }
      }).then((data) => {
        this.subjectData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    async search() {
      await this.$http.get('/online_student/', {
        params: this.queryInfo
      }).then((data) => {
        data.results.forEach(m => {
          m.checked = false
        })
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    pageCallback(data) {
      this.queryInfo.page = data
      this.search()
    },
    pageUserCallback(data) {
      this.formSearchUser.page = data
      this.getUserList()
    },
    async getUserList() {
      await this.$http.get('/userprofile/', {
        params: this.formSearchUser
      }).then((data) => {
        this.userData = data.results
        this.userDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    formatGender(value) {
      if (value === '1') {
        return '男'
      } else if (value === '0') {
        return '女'
      } else if (value === '男' || value === '女') {
        return value
      } else {
        return '--'
      }
    },
    formatAcademy(value) {
      const academyId = this.academyData.map(item => item.id)
      return this.academyData[academyId.indexOf(value)] ? this.academyData[academyId.indexOf(value)].title : '--'
    },
    formatMajor(value) {
      const subjectId = this.subjectData.map(item => item.id)
      return this.subjectData[subjectId.indexOf(value)] ? this.subjectData[subjectId.indexOf(value)].title : '--'
    },
    async getAcademy() {
      const params = {
        page: 1,
        size: 1000
      }
      await this.$http.get('/academy/', { params }).then((data) => {
        this.academyData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    async addOnlineStudent(item) {
      await this.$http.post('/online_student_save/', {
        userProfile_id: item.id,
        lessonOnline_id: this.$route.query.id
      }).then((data) => {
        if (data.code === '200') {
          this.$layer.msg('添加成功！')
          this.hideUserWindow()
          this.search()
        } else {
          this.$layer.msg(data.msg)
        }
      }).catch(() => {
        this.$layer.msg('添加失败！')
      })
    },
    async getClass() {
      await this.$http.get('/online_class/', {
        params: {
          page: 1,
          size: 10000,
          lessonOnline_id: this.$route.query.id
        }
      }).then((data) => {
        this.classData = data.results
      })
    },
    openClassWindow(item) {
      this.formClass.onlineStudent_id = item.id
      if (item.onlineClass_id) {
        this.formClass.onlineClass_id = item.onlineClass_id
      } else {
        this.formClass.onlineClass_id = ''
      }
      this.classShowClassWindow = {
        visibility: 'visible'
      }
    },
    hideClassWindow() {
      this.classShowClassWindow = {
        visibility: 'hidden'
      }
    },
    openBatchClassWindow() {
      const studentIds = []
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].checked) {
          studentIds.push(this.tableData[i].id)
        }
      }
      if (studentIds.length === 0) {
        this.$layer.msg('请选择学生！')
        return false
      }
      this.formBatchClass.onlineClass_id = ''
      this.formBatchClass.studentIds = studentIds
      this.classShowBatchClassWindow = {
        visibility: 'visible'
      }
    },
    hideBatchClassWindow() {
      this.classShowBatchClassWindow = {
        visibility: 'hidden'
      }
    },
    async saveClassInfo() {
      await this.$http.put('/online_student/' + this.formClass.onlineStudent_id + '/', {
        onlineClass_id: this.formClass.onlineClass_id
      }).then((data) => {
        this.$layer.msg('修改成功！')
        this.hideClassWindow()
        this.search()
      }).catch((error) => {
        console.log(error)
      })
    },
    async saveBatchClassInfo() {
      if (!this.formBatchClass.onlineClass_id) {
        this.$layer.msg('请选择班级！')
        return false
      }
      await this.$http.post('/online_student_batch_class/', {
        onlineClass_id: this.formBatchClass.onlineClass_id,
        studentIds: JSON.stringify(this.formBatchClass.studentIds)
      }).then((data) => {
        this.$layer.msg('修改成功！')
        this.hideBatchClassWindow()
        this.search()
      }).catch((error) => {
        console.log(error)
      })
    },
    async deleteClass(item) {
      await this.$http.put('/online_student/' + item.id + '/', {
        onlineClass_id: null
      }).then((data) => {
        this.$layer.msg('修改成功！')
        this.search()
      }).catch((error) => {
        console.log(error)
      })
    },
    cancelLesson (item) {
      this.$http.put('/online_student/' + item.id + '/', {
        isdel: 1
      }).then((data) => {
        this.search()
      }).catch(() => {
        this.$layer.msg('退出课程失败！')
      })
    },
    selectAll () {
      let hasNotChecked = false
      this.tableData.forEach(m => {
        if (!m.checked) {
          hasNotChecked = true
        }
      })
      if (hasNotChecked) {
        this.tableData.forEach(m => {
          m.checked = true
        })
      } else {
        this.tableData.forEach(m => {
          m.checked = false
        })
      }
    },
    async getSchool() {
      const params = {
        page: 1,
        size: 10000,
        status: 1
      }
      await this.$http.get('/school/', { params }).then((data) => {
        this.searceSchoolData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取学校下的所有院系
    async getSchoolAcademy(value) {
      const params = {
        page: 1,
        size: 10000,
        school_id: value,
        status: 1
      }
      await this.$http.get('/academy/', { params }).then((data) => {
        this.searchAcademyData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    // 打开上传弹窗
    showUploadWindow() {
      this.classShowUploadWindow = {
        visibility: 'visible'
      }
    },
    // 关闭上传弹窗
    hideUploadWindow() {
      this.classShowUploadWindow = {}
    },
    async xlsChange(e) {
      const uploadUrl = '/files/' + e.target.files[0].name
      await this.$http.put(uploadUrl, e.target.files[0]).then((data) => {
        this.uploadedCsv = data
        e.srcElement.value = null
      }).catch(() => {
        this.$parent.showMsg('上传失败！')
      })
    },
    async submitCsv() {
      this.errorList = []
      const uploadUrl = '/get_excel/'
      await this.$http.get(uploadUrl, {
        params: {
          file_name: this.uploadedCsv
        }
      }).then((data) => {
        if (data.length <= 1) {
          this.$parent.showMsg('表格中无数据！')
          return
        }
        if (data.length > 501) {
          this.$parent.showMsg('表格中数据大于500条，请分批上传！')
          return
        }
        data.splice(0, 1)
        this.uploadedCscData = data
        this.hideUploadWindow()
        this.classShowProcessWindow = {
          visibility: 'visible'
        }
        this.uploadedCsv = ''
        this.isFinishUpsert = false
        this.curCsvIndex = 0
        this.csvFinishText = ''
        this.errorList = []
        this.insertOne()
      }).catch(() => {
        this.$parent.showMsg('读取失败！')
      })
    },
    async insertOne() {
      if (this.curCsvIndex >= this.uploadedCscData.length) {
        this.csvFinishText = '上传完成'
        this.isFinishUpsert = true
        this.search()
        return
      }

      const row = this.uploadedCscData[this.curCsvIndex]
      // const academy = this.academyData.map(item => item.title)
      // const userData = this.tableData.map(item => item.username)
      // let usernameValid = false
      // let province = '', school = ''
      // region 数据检查开始

      if (row[0].toString().trim().length === 0) {
        this.errorList.push({ code: 0, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[0] + ']' + '请输入！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }
      const re = /^[A-Za-z0-9]*$/
      if (re.test(row[0].toString().trim()) === false) {
        this.errorList.push({ code: 0, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[0] + ']' + '用户名(学/工号)只能包含字母和数字' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      if (row[1].trim().length === 0) {
        this.errorList.push({ code: 0, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[1] + ']' + '请输入姓名！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      const schoolCheckData = await this.$http.get('/userprofile/', {
        params: {
          eq_username: row[0]
        }
      })

      let userInfo = null
      if (schoolCheckData.results.length === 0) {
        this.errorList.push({ code: 0, text: '[' + row[0] + ']' + '当前用户不存在！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      } else {
        userInfo = schoolCheckData.results[0]
      }

      if (userInfo.name !== row[1]) {
        this.errorList.push({ code: 0, text: '[' + row[0] + ']' + '姓名和系统中不匹配！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      await this.$http.post('/online_student_save/', {
        lessonOnline_id: this.lessonInfo.id,
        userProfile_id: userInfo.id
      }).then((data) => {
        if (data.code === '200') {
          this.errorList.push({ code: 1, text: '[' + row[0] + ']' + '导入成功！' })
          this.curCsvIndex++
          this.insertOne()
        } else {
          this.errorList.push({ code: 1, text: '[' + row[0] + ']' + data.msg })
          this.curCsvIndex++
          this.insertOne()
        }
      }).catch((error) => {
        console.log(error)
        this.errorList.push({ code: 0, text: '[' + row[0] + ']' + error.response.data[0] })
        this.curCsvIndex++
        this.insertOne()
      })
    }
  },
  mounted() {
    this.search()
    this.getAcademy()
    this.searchSubject()
    this.getUserList()
    this.getClass()
    this.getSchool()
  },
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    },
    teacherPageInfo() {
      return {
        page: this.formSearchUser.page,
        all: Math.ceil(this.userDataCount / this.formSearchUser.size),
        totalData: this.userDataCount
      }
    }
  }
}
</script>

<style scoped src="@/assets/css/project-detail.css"></style>

<style lang="less" scoped>
.panel-content {
  padding: 20px 40px;
}

.c-content {
  margin: 0;
  transform: translate(-50%, -50%);
}

.itemStatus {
  img {
    width: 120px;
  }
}

#c-panel {
  z-index: 2;
}

.c-content {
  min-height: 500px;
}

.active {
  color: #266dc7 !important;
  text-decoration: underline;
}

.course_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .panel-title {
    p {
      display: inline-block;
      margin-right: 20px;

      &:last-child {
        color: #999;
        font-size: 16px;
      }
    }
  }

  .course_btn {
    display: flex;
    flex-direction: row;
    div {
      margin-left: 20px;
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;

      &:first-child {
        background: #25c7a8;
      }

      &:nth-child(2) {
        border: 1px solid #73D6CA;
        color: #73D6CA;
        background: #fff;
      }
    }
  }
}

.crumb_nav {
  color: #999;
  margin-top: 20px;
}

.add-btn {
  width: unset;
  height: unset;
  line-height: normal;
}

.item img {
  max-height: 40px;
  margin-top: 4px;
}

#list td,
.f_list td {
  padding: 5px;
}

#list td a.nopublish {
  color: #bbbbbb;
}
#uList td {
  padding: 1px;
}

.form_content .divLabel {
  margin-left: 0px;
}

#dialog_content2 {
  max-height: 200px;
  overflow: auto;
}
</style>
